import {
  DataTable,
  FlexBox,
  Spinner,
  Switch,
  Text,
} from '@dixa/lib-shared-habla';

import { MessengerSetting } from '../../../Panel/DixaMessengerPanel';
import { DixaMessengerCSAT } from '../../types';

type Props = {
  messengers: MessengerSetting[];
  onStatusChange: (
    StatusChange: DixaMessengerCSAT.MessengerStatusChange,
  ) => void;
  isLoading?: boolean;
  disabled?: boolean;
};

export const MessengersList = ({
  messengers,
  onStatusChange,
  isLoading,
  disabled,
}: Props): JSX.Element => {
  if (isLoading) {
    return (
      <FlexBox height="100%" alignItems="center" justifyContent="center">
        <Spinner />
      </FlexBox>
    );
  }

  return (
    <DataTable
      data={messengers}
      columns={[
        {
          label: 'Messenger',
          selector: ({ name }) => <Text.Paragraph>{name}</Text.Paragraph>,
        },
        {
          label: 'Enabled',
          selector: ({ enabled, settings, id }) => (
            <Switch
              name={id}
              value={id}
              checked={enabled}
              disabled={disabled}
              onChange={() =>
                onStatusChange({
                  newStatus: !enabled,
                  id,
                  settings,
                })
              }
            />
          ),
          style: {
            width: 0,
          },
        },
      ]}
    />
  );
};
